import { ReactNode } from "react"

export default function CenterElement({ children }: { children: ReactNode }) {
  return (
    <div className="w-full p-4 flex items-center justify-center">
      {children}
    </div>
  )
}
